import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import authService from "./authService.js";
import Cookies from 'js-cookie';

export const initialStateCommon = {
  accessToken: localStorage.getItem('accessToken') || null,
  userData: localStorage.getItem('userData') ? JSON.parse(localStorage.getItem('userData')) : null
};

export const login = createAsyncThunk(
  "auth/login",
  async ({ data, encrypt = false }, thunkAPI) => {
    try {
      return await authService.authUser(data, encrypt);
    } catch (error) {
      const message =
        error?.response?.data?.response_string ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue({ message, error });
    }
  }
);

export const mfa = createAsyncThunk(
  "auth/mfa-verify",
  async ({ data, encrypt = false }, thunkAPI) => {
    try {
      return await authService.authMfa(data, encrypt);
    } catch (error) {
      const message =
        error?.response?.data?.response_string ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue({ message, error });
    }
  }
);

export const authSlice = createSlice({
  name: "auth",
  initialState: initialStateCommon,
  reducers: {
    logout: (state) => {
      state.accessToken = null;
      state.userData = null;
      localStorage.removeItem('accessToken');
      localStorage.removeItem('userData');
      Cookies.remove('token', {
        domain: '.chola.murugappa.com',
        path: '/'
      });
      const partnerSlug = sessionStorage.getItem('partnerSlug');
      if (partnerSlug) {
        window.location.href = `/${partnerSlug}`;
      } else {
        window.location.href = '/login';
      }
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(login.pending, (state) => {
        state.accessToken = null;
        state.userData = null;
      })
      .addCase(login.fulfilled, (state, action) => {
        if (action?.payload?.response_code === "S100" && action?.payload?.response_data) {
          const { access_token } = action.payload.response_data;
          const userData = action.payload; // Store entire response as userData
          
          if (access_token) {
            localStorage.setItem('accessToken', access_token);
            localStorage.setItem("userData", JSON.stringify(userData));
            state.accessToken = access_token;
            state.userData = userData;
            Cookies.set('token', access_token, {
              domain: '.chola.murugappa.com',
              path: '/',
              secure: true,
              sameSite: 'None',
              expires: 7
            });
          }
        }
      })
      .addCase(login.rejected, (state, action) => {
        state.accessToken = null;
        state.userData = null;
      })
      .addCase(mfa.pending, (state) => {
        state.accessToken = null;
        state.userData = null;
      })
      .addCase(mfa.fulfilled, (state, action) => {
        if (action?.payload?.response_code === "S100" && action?.payload?.response_data) {
          const { access_token } = action.payload.response_data;
          const userData = action.payload; // Store entire response as userData
          
          if (access_token) {
            localStorage.setItem('accessToken', access_token);
            localStorage.setItem("userData", JSON.stringify(userData));
            state.accessToken = access_token;
            state.userData = userData;
            Cookies.set('token', access_token, {
              domain: '.chola.murugappa.com',
              path: '/',
              secure: true,
              sameSite: 'None',
              expires: 7
            });
          }
        }
      })
      .addCase(mfa.rejected, (state, action) => {
        state.accessToken = null;
        state.userData = null;
      })
  }
});

export const {
  logout
} = authSlice.actions;
export default authSlice.reducer;